import React from 'react';
import "./filter.scss";
import Dropdown from '../../../common/dropdown-v2/dropdown';
import DropdownV4 from '../../../common/dropdown-v4/dropdown';

import SchoolApi from '../../../../apis/school'
import MasterDataApi from '../../../../apis/master-data'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';

class FilterComponent extends React.Component {

    state = {
        showShadow: false,
        showFilters: false,
        disableGo: true,

        boardsDropdownItems: [],
        classDropdownItems: [],
        chapterDropDownItems: [],
        teachersDropDownItems: [],
        selectedBoard: "",
        selectedClass: "",
        selectedChapterKey: [],
        selectedTeachersId: [],
        eloDropdownItems: [],
        disableClass: true,
        disableChapters: true

    }
    typeDropdwon = [{ title: "Normal", value: "NORMAL" }, { title: "Diagnostic", value: "DIAGNOSTIC" }]

    classSectionHash = {}
    conceptHash = {}
    eloHash = {}

    constructor(props) {
        super(props)
        if (this.props.filter) {
            this.state.selectedBoard = this.props.filter?.board
            this.state.selectedClass = this.props.filter?.class
            this.state.selectedChapter = [this.props.filter?.chapterKey]
            this.state.selectedSection = this.props.filter?.sectionId
        }
    }

    componentDidMount() {
        this.getClasses()

    };

    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards })
                } else {
                    this.setState({ selectedBoard: boards[0]?.name })
                }
                this.setState({ classDropdownItems: classes, })
            }).catch(err => {
            })
    }

    getSections(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass

        if (this.classSectionHash[payload.class]) {
            this.setState({ sectionDropdownItems: this.classSectionHash[payload.class], selectedSection: "" })
            this.reloadDropdown()
            return
        }

        SchoolApi.getSections(payload)
            .then(response => {
                let sections = []
                for (let i = 0; i < response.response.length; i++) {
                    sections.push({
                        title: response.response[i].section,
                        value: response.response[i]._id,
                    })
                }
                this.classSectionHash[payload.class] = sections
                this.setState({ sectionDropdownItems: sections, selectedSection: "" })
                this.reloadDropdown()
            }).catch(err => {
            })
    }

    getChapters(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = this.state.selectedBoard

        MasterDataApi.getChapterList(payload)
            .then(response => {
                let chapters = []
                response = response.data
                this.setState({ masterDataId: response._id })
                for (let i = 0; i < response.chapters.length; i++) {
                    let chapter = response.chapters[i], concepts = []
                    chapters.push({
                        title: chapter.title,
                        value: chapter.key,
                    })

                    for (let j = 0; j < chapter.concepts?.length; j++) {
                        let concept = chapter.concepts[j]
                        concepts.push({
                            title: concept.title,
                            value: concept.key,
                            order: j + 1
                        })
                        // this.buildElosDropdown(concept)
                    }

                    this.conceptHash[chapter.key] = concepts
                }
                this.setState({ chapterDropDownItems: chapters, selectedChapter: "", reloadChapterDropdown: true }, () => {
                    this.setState({ reloadChapterDropdown: false })
                })
                this.reloadDropdown()
            }).catch(err => {
            })
    }

    sortPayload(nodes) {
        let orderedList = [];
        let workFlowNodeHash = {};
        let startingNode;

        for (let i = 0; i < nodes.length; i++) {

            let nodeId = nodes[i]._id.toString();

            if (nodes[i].previousNode == null)
                startingNode = nodeId;

            workFlowNodeHash[nodeId] = nodes[i];
        }

        let tempNode = startingNode;

        for (let i = 0; i < nodes.length; i++) {
            if (tempNode) {
                orderedList.push(workFlowNodeHash[tempNode]);
                tempNode = workFlowNodeHash[tempNode].nextNode;
            }
        }
        return orderedList
    }


    getWorkflowNodes(payload = {}) {
        payload = {
            class: this.state.selectedClass,
            board: this.state.selectedBoard,
            chapterKey: this.state.selectedChapter,
            masterDataId: this.state.masterDataId
        }
        MasterDataApi.getWorkflowNodes(payload)
            .then(response => {
                response = response.data
                for (let i = 0; i < response.length; i++) {
                    let chapter = response[i], elos = []

                    for (let j = 0; j < chapter.elos?.length; j++) {
                        let elo = chapter.elos[j]
                        elos.push({
                            title: elo.title,
                            value: elo.id,
                            conceptTitle: chapter.conceptTitle,
                            conceptValue: chapter.conceptKey
                        })
                    }
                    if (this.eloHash[chapter.conceptKey]) {
                        this.eloHash[chapter.conceptKey].push(...elos)
                    } else {
                        this.eloHash[chapter.conceptKey] = elos
                    }
                }

                let eloList = this.sortPayload(response)
                this.setState({ orderedEloList: eloList })
            }).catch(err => {
            })
    }

    buildElosDropdown(concept) {
        let elos = []
        for (let i = 0; i < concept?.subConcepts?.length; i++) {
            let subConcept = concept.subConcepts[i]
            for (let j = 0; j < subConcept.elo?.length; j++) {
                let elo = subConcept.elo[j]
                elos.push({
                    title: elo.title,
                    value: elo.eloId,
                    conceptTitle: concept.title,
                    conceptValue: concept.key
                })
            }

        }
        this.eloHash[concept.key] = elos
        return
    }

    reloadDropdown() {
        this.setState({ reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })
    }

    resetDropDowns(callback) {
        this.setState({
            selectedBoardId: "",
            selectedClassId: "",
            chapterDropdownItems: [],
        }, () => { if (callback) callback(); });
    }


    onGo() {
        let payload = {
            board: this.state.selectedBoard,
            class: this.state.selectedClass,
            chapterKey: this.state.selectedChapterKey,
            assignedTo: this.state.selectedTeachersId
        };
        if (this.props.onGo) {
            this.props.onGo(payload)
        }
    }

    refreshPage() {
        this.setState(
            { reload: true },
            () => this.setState({ reload: false })
        )
    }

    toggleFilters = () => {
        this.setState({ showFilters: !this.state.showFilters })
    }

    onSelectDropDown = (option, key) => {
        this.setState({ [key]: option?.value }, () => {
            if (key == "selectedClass") {
                this.getSections({ class: option?.value })
                this.getChapters()
            }

            if (key == "selectedChapter") {
                if (option?.value) {
                    this.getWorkflowNodes()
                    this.setState({ conceptDropownItems: this.conceptHash[option?.value], reloadConceptDropdown: true }, () => {
                        this.setState({ reloadConceptDropdown: false })
                    })
                } else {
                    this.setState({ conceptDropownItems: [], reloadConceptDropdown: true }, () => {
                        this.setState({ reloadConceptDropdown: false })
                    })
                }
                this.reloadDropdown()
            }

        })
    }

    onMultiSelectDropdown = (options, key) => {
        let value = [], eloDropdownItems = []
        options = options.sort((a, b) => a.order - b.order)
        for (let i = 0; i < options.length; i++) {
            let option = options[i]
            value.push(option?.value)

            if (key == "selectedConcept") {
                if (this.eloHash[option?.value]) {

                    let elo = this.eloHash[option?.value]
                    let elos = elo.map((e) => {
                        return {
                            ...e,
                            conceptName: `Concept ${i + 1}`
                        }
                    })
                    eloDropdownItems.push(...elos)
                }
            }
        }
        this.setState({ reloadDropdown: true, eloDropdownItems, [key]: value }, () => {
            this.setState({ reloadDropdown: false })
        })
    }


    onSelectElo = (options) => {
        let values = options.map(option => option?.value)
        let result = []
        for (let i = 0; i < this.state.orderedEloList?.length; i++) {
            let eloId = this.state.orderedEloList[i]?.elos[0]?.id
            if (values.includes(eloId)) {
                result.push(eloId)
            }
        }

        this.setState({ selectedElo: result }, () => {
        })
    }

    handleCreatedDateEvent = (event, picker) => {

        this.createdDateRangeStart = new Date(picker.startDate);
        this.createdDateRangeEnd = new Date(picker.endDate).toLocaleDateString() == new Date().toLocaleDateString() ? new Date() : new Date(picker.endDate);

        this.setState({ createdDate: this.createdDateRangeStart.toLocaleDateString(), selectedCreatedDateRange: this.createdDateRangeStart.toLocaleDateString() + "  -  " + this.createdDateRangeEnd.toLocaleDateString() });
    }

    handleDueDateEvent = (event, picker) => {
        this.dueDateRangeStart = new Date(picker.startDate);
        this.dueDateRangeEnd = new Date(picker.endDate).toLocaleDateString() == new Date().toLocaleDateString() ? (new Date(new Date().setHours(23, 59, 59, 999)).toISOString()).slice(0, -1) : (new Date(new Date(picker.endDate).setHours(23, 59, 59, 999)).toISOString()).slice(0, -1);

        this.setState({ dueDate: new Date(this.dueDateRangeStart).toLocaleDateString(), selectedDueDateRange: new Date(this.dueDateRangeStart).toLocaleDateString() + "  -  " + new Date(this.dueDateRangeEnd).toLocaleDateString() });
    }


    onClickGo = () => {

        let payload = {}

        if (this.state.selectedBoard) payload.board = this.state.selectedBoard
        if (this.state.selectedClass) payload.class = this.state.selectedClass
        if (this.state.selectedSection) payload.section = this.state.selectedSection
        if (this.state.selectedChapter) payload.chapter = this.state.selectedChapter?.join(",")
        if (this.dueDateRangeStart) payload.dueDateRangeStart = this.dueDateRangeStart
        if (this.dueDateRangeEnd) payload.dueDateRangeEnd = (new Date(new Date(this.dueDateRangeEnd).setHours(23, 59, 59, 999)).toISOString()).slice(0, -1)
        if (this.createdDateRangeStart) payload.createdDateRangeStart = this.createdDateRangeStart
        if (this.createdDateRangeEnd) payload.createdDateRangeEnd = (new Date(new Date(this.createdDateRangeEnd).setHours(23, 59, 59, 999)).toISOString()).slice(0, -1)
        if (this.state.selectedType) payload.type = this.state.selectedType
        if (this.props.onGo) {
            this.props.onGo(payload)
        }
    }

    clearFilter = () => {

        this.props.onGo && this.props.onGo({})
        this.setState({
            selectedBoard: "",
            selectedClass: "",
            selectedSection: "",
            selectedChapter: "",
            dueDate: '',
            createdDate: "",
            selectedType: "",
            selectedCreatedDateRange: '',
            selectedDueDateRange: '',
            chapterDropDownItems: [],
            sectionDropdownItems: []
        }, () => {
            this.dueDate = ""
            this.createdDate = ""
            this.createdDateRangeStart = ''
            this.createdDateRangeEnd = ''
            this.dueDateRangeStart = ''
            this.dueDateRangeEnd = ''
            this.refreshPage()

        })

    }


    render() {

        return (

            <div className="new-homwwork-filter">
                <div className="filter-header" >
                    <div className="d-inline" onClick={this.toggleFilters}>
                        <div className="filter-title d-inline">{"Filters"}</div>
                        <div className="d-inline"><i class={this.state.showFilters ? "filter-arrow up" : "filter-arrow down"}></i></div>
                    </div>
                </div>
                {
                    !this.state.reload ?
                        <div className={this.state.showFilters ? "filter-content" : "filter-content d-none"} >
                            <div className="row">
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Created Date
                                    </div>
                                    <div>
                                        <DateRangePicker onHide={this.handleCreatedDateEvent} onCancel={() => { }}
                                            autoApply
                                            maxDate={new Date().toLocaleDateString()}
                                            initialSettings={{ singleDatePicker: false, startDate: this.createdDatesRangeStart, endDate: this.createdDateRangeEnd, autoUpdateInput: false }}
                                            locale={{
                                                'format': 'DD/MM/YYYY'
                                            }}
                                            // maxDate={new Date().toLocaleDateString()}
                                        ><input className="cw-input bg-white" placeholder="Select date" value={this.state.selectedCreatedDateRange}></input>
                                        </DateRangePicker>


                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Due Date
                                    </div>
                                    <div>
                                        <DateRangePicker onHide={this.handleDueDateEvent} onCancel={() => { }}
                                            autoApply
                                            maxDate={new Date().toLocaleDateString()}
                                            initialSettings={{ singleDatePicker: false, startDate: this.dueDatesRangeStart, endDate: this.dueDateRangeEnd, autoUpdateInput: false }}
                                            locale={{
                                                'format': 'DD/MM/YYYY'
                                            }}
                                            // maxDate={new Date().toLocaleDateString()}
                                        ><input className="cw-input bg-white" placeholder="Select date" value={this.state.selectedDueDateRange}></input>
                                        </DateRangePicker>
                                    </div>
                                </div>

                                {
                                    this.state.boardsDropdownItems.length > 1 ?
                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                            <div className="filter-input-label">
                                                Boards
                                            </div>
                                            <div>
                                                <Dropdown
                                                    placeholder='Select a board'
                                                    options={this.state.boardsDropdownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                                    text={"title"}
                                                    value={this.state.selectedBoard}

                                                />
                                            </div>
                                        </div>
                                        : ""
                                }
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Class
                                    </div>
                                    <div>
                                        <Dropdown
                                            placeholder='Select a Class'
                                            options={this.state.classDropdownItems}
                                            onSelect={(option) => this.onSelectDropDown(option, "selectedClass")}
                                            text={"title"}
                                            value={this.state.selectedClass}

                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Section
                                    </div>
                                    <div>
                                        {
                                            !this.state.reloadDropdown ?
                                                <Dropdown
                                                    key="class"
                                                    placeholder='Select a Section'
                                                    options={this.state.sectionDropdownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedSection")}
                                                    text={"title"}
                                                    value={this.state.selectedSection}
                                                >
                                                </Dropdown>
                                                : ""
                                        }
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Chapter
                                    </div>
                                    <div>
                                        {
                                            !this.state.reloadChapterDropdown ?
                                                <DropdownV4
                                                    placeholder='Select Chapter'
                                                    options={this.state.chapterDropDownItems}
                                                    onSelect={(option) => this.onMultiSelectDropdown(option, "selectedChapter")}
                                                    text={"title"}
                                                    multiSelect
                                                />
                                                : ""
                                        }
                                        {/* </Dropdown> */}
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Assessment Type
                                    </div>
                                    <div>
                                        <Dropdown
                                            key="class"
                                            placeholder='Select a Type'
                                            options={this.typeDropdwon}
                                            onSelect={(option) => this.onSelectDropDown(option, "selectedType")}
                                            text={"title"}
                                            value={this.state.selectedType}
                                        >
                                        </Dropdown>
                                    </div>
                                </div>

                                <div className="col my-auto">
                                    <div className="filter-button  d-inline-block">
                                        <button className={`cw-button`} onClick={this.onClickGo.bind(this)}>{"GO"}</button>
                                    </div>
                                    <div className="filter-button ml-3 d-inline-block">
                                        <button className={`cw-button clear-btn`} onClick={this.clearFilter.bind(this)}>{"CLEAR"}</button>
                                    </div>
                                </div>
                            </div>
                        </div> : ""

                }
            </div>


        );
    }

}

export default FilterComponent;